/** Permisos de cierre diario — alineados con backend userCanCaja(). */

/** Resumen del día actual (GET /caja/cierre-dia). No requiere historial. */
export function canVerResumenCaja(hasPermission) {
  return (
    hasPermission('caja', 'ver') ||
    hasPermission('caja', 'crear') ||
    hasPermission('caja', 'cerrar')
  );
}

/** Alias legacy */
export function canVerCierreCaja(hasPermission) {
  return canVerResumenCaja(hasPermission);
}

export function canCerrarCaja(hasPermission) {
  return hasPermission('caja', 'crear') || hasPermission('caja', 'cerrar');
}

export function canCorregirCierreCaja(hasPermission) {
  return hasPermission('caja', 'editar') || hasPermission('caja', 'corregir_cierre');
}

/** Historial amplio (GET /caja/cierres). Solo admin/gerente o permiso explícito. */
export function canVerHistorialCierres(hasPermission) {
  return hasPermission('caja', 'ver_cierres') || canCorregirCierreCaja(hasPermission);
}

export function canEliminarMovimientoCaja(hasPermission) {
  return hasPermission('caja', 'eliminar');
}
